import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../get-base-url';
import { useLocation, useParams } from 'react-router-dom';
import ResearchFamilyNotificationsShared from '../../research-notifications/research-family';
import { BreadcrumbItem } from '../../breadcrumb';

interface ResearchFamilyNotificationsCivilStatusSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const ResearchFamilyNotificationsCivilStatusShared = ({
  scope,
  items,
}: ResearchFamilyNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl = useMemo(() => {
    return `${useLocation().pathname}/dettaglio`;
  }, [useLocation().pathname]);

  return (
    <Fragment>
      <ResearchFamilyNotificationsShared
        goBackUrl={goBackUrl}
        redirectUrl={redirectUrl}
        items={items}
      />
    </Fragment>
  );
};

ResearchFamilyNotificationsCivilStatusShared.displayName =
  'Research Family Notifications CivilStatusShared component';

export default ResearchFamilyNotificationsCivilStatusShared;
